import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DeleteConfirmationModal from "../../../components/commonComponent/DeleteConfirmationModal";
import Pagination from "../../../components/commonComponent/Pagination";
import Search from "../../../components/commonComponent/Search";
import Table from "../../../components/commonComponent/Table";
import ViewModal from "../../../components/commonComponent/ViewModal";
import { FIELDS, TOAST_MESSAGES } from "../../../constants/SiteConstants";
import useModal from "../../../hooks/useModal";
import "../../../styles/SolarStation.css";
import { deleteData, fetchData, getCurrentData } from "../../../utils/utils";
import useLoader from "../../../hooks/useLoader";

const API_URL = process.env.REACT_APP_API_URL;

const columns = [{ header: FIELDS.TITLE, accessor: "title" }];

const ITEMS_PER_PAGE = 10;

const Services = () => {
  const [data, setData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [error, setError] = useState(null);
  const { loading, showLoader, hideLoader } = useLoader();

  const {
    showDeleteModal,
    showViewModal,
    selectedItem,
    handleOpenDeleteModal,
    handleCloseDeleteModal,
    handleOpenViewModal,
    handleCloseViewModal,
  } = useModal();
  const navigate = useNavigate();

  useEffect(() => {
    if (searchTerm.length >= 2 || searchTerm === "") {
      fetchData(
        `${API_URL}/services/getAllServices`,
        setData,
        setError,
        setFilteredData,
        currentPage,
        searchTerm,
        showLoader,
        hideLoader
      );
    }
  }, [currentPage, searchTerm]);

  const handleSearch = (searchValue) => {
    if (searchValue.length >= 2) {
      setSearchTerm(searchValue);
      setCurrentPage(1);
    } else if (searchValue.length === 0) {
      setSearchTerm("");
      setCurrentPage(1);
    }
  };

  const handleDeleteConfirm = () => {
    deleteData(`${API_URL}/services/deleteService`, selectedItem._id, setError)
      .then(() => {
        setData((prevData) =>
          prevData.filter((item) => item._id !== selectedItem._id)
        );
        toast.success(TOAST_MESSAGES.DELETED);
        fetchData(
          `${API_URL}/services/getAllServices`,
          setData,
          setError,
          setFilteredData,
          currentPage,
          searchTerm,
          showLoader,
          hideLoader
        );
      })
      .catch((error) => {
        setError(error);
        toast.error(TOAST_MESSAGES.ERROR_DELETE);
      });
    handleCloseDeleteModal();
  };
  const totalPages = Math.ceil(filteredData.length / ITEMS_PER_PAGE);
  const currentData = getCurrentData(filteredData, currentPage, ITEMS_PER_PAGE);

  const fieldsToShow = {
    Title: "title",
  };

  return (
    <div>
      <h2 className="capitalize font-bold text-[24px] mb-4">Services List</h2>

      <div className="flex justify-between items-center shadow-md px-8 py-[10px] rounded-md bg-[#fff] text-base mb-4">
        <div className="flex items-center">
          <div className="search-filter-container">
            <Search searchFields={["Title"]} onSearch={handleSearch} />
          </div>
        </div>

        <Link
          to="/services/add"
          className="inline-flex items-center justify-center rounded-md border border-white px-4 py-1.5 text-center font-medium text-white bg-[#1C2434] hover:bg-opacity-90"
        >
          Add Service
        </Link>
      </div>

      <div className="table-container">
        <Table
          columns={columns}
          data={currentData}
          showIndex={true}
          currentPage={currentPage}
          itemsPerPage={ITEMS_PER_PAGE}
          onDelete={handleOpenDeleteModal}
          onUpdate={(item) => navigate(`/services/edit/${item._id}`)}
          onView={handleOpenViewModal}
          actions={{
            showView: true,
            showEdit: true,
            showDelete: true,
          }}
          loading={loading}
        />
        <Pagination
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={(page) => setCurrentPage(page)}
        />
      </div>
      <DeleteConfirmationModal
        show={showDeleteModal}
        onHide={handleCloseDeleteModal}
        onConfirm={handleDeleteConfirm}
      />

      <ViewModal
        show={showViewModal}
        onHide={handleCloseViewModal}
        data={selectedItem}
        fields={fieldsToShow}
      />
    </div>
  );
};

export default Services;
